<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/auth'"></i>
                    </div>
                    <div class="col text-center">
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br>
            <div class="container-fluid" style="padding-top:56px;">
                <div class="row justify-content-center">
                    <div class="col-11">
                        <div style="font-size:30px;color:#6C7072;">
                            送信されたメールを<br>
                            確認してください
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row justify-content-center">
                    <div class="col-10">
                        <img src="/images/Group12882.png" class="img-fluid">
                    </div>
                </div>
                <br>
                <div class="row justify-content-center">
                    <div class="col-10">
                        <div style="color:#6C7072;">
                            regster@luna_matching.comから<br>
                            <span style="color:#6B4EFF">{{ email }}</span><br>
                            に、パスワード再設定用メールを送信しました。<br><br>
                            24時間以内に、送信されたメールを確認して下さい。<br>
                            経過した場合は、再度メールアドレスを入力して下さい。<br>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row justify-content-center">
                    <div class="col-10 text-center">
                        <p class="error-text" id="error-box" v-if="is_login_error">
                            <i class="bi bi-x-circle-fill"></i>登録されていないメールアドレスです。
                        </p>
                        <a style="color:#6B4EFF" @click="setAuth">再度メールを送信する</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            is_login_error: false,
        };
    },
    methods: {
        async setAuth() {
            await axios.post("/api/auth/pass/reset", {
                email: this.email,
            })
                .then((response) => {
                    if (response.data.res == '546') {
                        this.is_login_error = true
                    }
                })
                .catch(function (error) {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('メールの送信に失敗しました。');
                    }
                })
        },
    },
    mounted() {
        this.email = this.$route.params['mail']
    },
}
</script>
<style scoped>
.link {
    color: #212529
}

.link:hover {
    color: #212529
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    padding-top: 20px;
    height: 60px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
